import { getRegisterFunction } from '../../utils/register.js';
import { OneUxCheckboxGroupElement } from './OneUxCheckboxGroupElement.js';
export const register = getRegisterFunction(OneUxCheckboxGroupElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-checkbox-group': OneUxCheckboxGroupElement;
    "checkbox-group-648d8bc1b9f6123af44012d1b5517693": OneUxCheckboxGroupElement;
  }
}